import { createClient } from '@supabase/supabase-js'


const supabaseUrl = process.env.VUE_APP_SUPABASE_URL // 替换为你的URL
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
